import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";

const AgentWisePerformanceSummaryReport = ({
  openAgentWisePerformanceSummaryReport,
  dateFrom,
  dateTo,
  selectedRegionIds,
  changeRegionIds,
  reportUrl
}) => {
  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [allreportsNew, setAllReportsNew] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const timeoutRef = useRef(null);

  const [dataTable, setDataTable] = useState({
    page: 0,
    size: 10,
    search: "",
    order: null,
  });

  const setTable = (tableState) => {
    setDataTable({
      page: tableState.page,
      search: tableState.searchText,
      size: tableState.rowsPerPage,
      order: tableState.sortOrder,
    });
  };

  const columns = [
    {
      label: "Branch",
      name: "branchName",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Teller",
      name: "tellerName",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Date",
      name: "loginDate",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Total Serving Time",
      name: "totalServingTime",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Average Serving Time",
      name: "avgServingTime",
      options: {
        sort: true,
        filter: false,
      },
    },    {
      label: "Assigned Transactions",
      name: "assignedTransactions",
      options: {
        sort: true,
        filter: false,
      },
    },    {
      label: "Completed Transactions",
      name: "completedTransactions",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Completed Tokens",
      name: "completedTokens",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "No show Count",
      name: "noShowCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "No show recalled Count",
      name: "recalledNoShowsCount",
      options: {
        sort: true,
        filter: false,
        // customBodyRender: (value) => (
        //   <p className="m-0">{value !== null ? <>{value} %</> : <>-</>}</p>
        // ),
      },
    },
    {
      label: "Waiting Count",
      name: "waitingCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Waiting recalled",
      name: "recalledWaitedCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Served Missing Tokens",
      name: "servedMissingTokensCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Problematic Tokens",
      name: "problematicTokensCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Max Service Time",
      name: "maxServingTime",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Total Login Time",
      name: "totalLoginTime",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Total Idle Time",
      name: "totalIdleTime",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Total Breaks",
      name: "breaksCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Total Breaks Time",
      name: "totalBreakTime",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Within Accepted Transactions",
      name: "withinAcceptedTransactionsCount",
      options: {
        sort: true,
        filter: false,
      },
    },
    {
      label: "Service Level",
      name: 'serviceLevel',
      options: {
        sort: true,
        filter: false,
        customBodyRender: (value) => (
            <p className='m-0'>
              {value !== null ? (
                  <>{value} %</>
              ) : <>-</>}
            </p>
        )
      }
    },
  ];

  const options = {
    filterType: "dropdown",
    filter: false,
    responsive: "vertical",
    serverSide: true,
    count: count,
    download: false,
    jumpToPage: true,
    selectableRows: "none",
    storageKey: "_ar_awpsr_table",
    print: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [10, 20, 30, 50, 100],
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          getAgentWisePerformanceSummaryReport(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "sort":
          getAgentWisePerformanceSummaryReport(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "changeRowsPerPage":
          setRowsPerPage(tableState.rowsPerPage);
          getAgentWisePerformanceSummaryReport(
            tableState.page,
            tableState.sortOrder,
            tableState.searchText,
            tableState.rowsPerPage
          );
          setTable(tableState);
          break;
        case "search":
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(
            () =>
              getAgentWisePerformanceSummaryReport(
                tableState.page,
                tableState.sortOrder,
                tableState.searchText,
                tableState.rowsPerPage
              ),
            2000
          );
          setTable(tableState);
          break;
        default:
          break;
      }
    },
  };

  // when pick date, call getAgentWisePerformanceSummaryReport function
  useEffect(() => {
    if (openAgentWisePerformanceSummaryReport) {
      if (dateFrom.length > 0 && dateTo.length > 0) {
        getAgentWisePerformanceSummaryReport(0, null, null, rowsPerPage);
      }
    }
  }, [openAgentWisePerformanceSummaryReport, dateFrom, dateTo]);

  // when change selected region array, call getAgentWisePerformanceSummaryReport - useEffect
  useEffect(() => {
    if (openAgentWisePerformanceSummaryReport) {
      getAgentWisePerformanceSummaryReport(0, null, null, rowsPerPage);
    }
  }, [changeRegionIds]);

  // getAgentWisePerformanceSummaryReport - function
  const getAgentWisePerformanceSummaryReport = (
    page,
    sortOrder,
    search,
    size
  ) => {
    setIsLoading(true);

    axios({
      method: "POST",
      url: `${reportUrl}/report-controller/agent-performance-summary-report`,
      headers: {
        Authorization: token,
      },
      data: {
        "page": page,
        "size": size,
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "sort": sortOrder,
        "searchText": search,
        branchIds: selectedRegionIds
      }
    })
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        setAllReportsNew(data.content);
        setCount(data.totalElements);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);

        if (error.response !== undefined) {
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  return (
    <>
      <div>
        <ToastContainer />
      </div>
      <MUIDataTable
        title={
          <>
            {isLoading ? (
              <CircularProgress color="secondary" size={20} />
            ) : (
              <>{count} records.</>
            )}
          </>
        }
        data={allreportsNew}
        columns={columns}
        options={options}
        className="text-center-table"
      />
    </>
  );
};

export default AgentWisePerformanceSummaryReport;
